// extracted by mini-css-extract-plugin
export var active = "_cx-2";
export var recordingDot = "_cx-1";
export var recordingIndicator = "_cx-0";